import { render, staticRenderFns } from "./ParticipantDataAssignment.vue?vue&type=template&id=47ea43a9&scoped=true&"
import script from "./ParticipantDataAssignment.vue?vue&type=script&lang=ts&"
export * from "./ParticipantDataAssignment.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipantDataAssignment.vue?vue&type=style&index=0&id=47ea43a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea43a9",
  null
  
)

export default component.exports